import { BaseSyntheticEvent } from 'react';
import { SyntheticEvent } from '../SyntheticEvent';

/**
 * @param {KeyboardEvent} evt
 * @returns {boolean} `true` if any modifier (alt, ctrl, meta, or shift) is pressed
 */
export const isModifierPressed = (evt: KeyboardEvent) =>
  evt.altKey || evt.ctrlKey || evt.metaKey || evt.shiftKey;

export const stopPropagationHandler = (evt: BaseSyntheticEvent | Event) => {
  if (evt) evt.stopPropagation();
};

interface RepeatHandle {
  active: boolean;
  count: number;
  stop: () => void;
}

export const repeatUntilEventOnElement = (
  callback: () => void,
  frequency: number,
  element: HTMLElement,
  events: string[]
): RepeatHandle => {
  const handle: RepeatHandle = {
    active: true,
    count: 0,
    stop,
  };

  const timer = setInterval(() => {
    callback();
    handle.count += 1;
  }, frequency);

  function stop() {
    handle.active = false;
    clearInterval(timer);
    events.forEach((event) => {
      element.removeEventListener(event, stop);
    });
  }

  events.forEach((event) => {
    element.addEventListener(event, stop);
  });

  return handle;
};

export const preventDefaultHandler = (evt: SyntheticEvent<MouseEvent>) => {
  if (evt) evt.preventDefault();
};
